import styled from 'styled-components';

import CommonContainer from 'ggApp/shared/common/Container';

import ExpandedItemComponent from '../ExpandedItem';

const Wrap = styled(CommonContainer)``;

const ExpandedItem = styled(ExpandedItemComponent)`
    width: 100%;
    height: 100%;
`;

export { Wrap, ExpandedItem };
